<template>
    <div id="Categories">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Create and edit categories</div>
            <p class="subtitle">Click <a href="https://www.youtube.com/watch?v=ZKb77JtLQg0&fbclid=IwAR1l6Qjl2PKgw0b3w0ZyJxtI-ojZjnWHqT5foOB-L-U4xCmsqaSuDyfj8hg" target="_blank">here</a> to watch a short tutorial</p>
        </div>
        <!--<hr>-->
        <div class="columns is-multiline box">
            <div class="column is-2" data-tour-cat-step="2">
                <span class="heading">Background color </span> <swatches :row-length="5" :show-border="true" v-model="color" show-fallback :colors="material"></swatches>
            </div>
            <div class="column is-1" data-tour-cat-step="3">
                <span class="heading">Text color </span> <swatches v-model="text_color" :show-border="true" show-fallback colors="text-basic"></swatches>
            </div>
            <div class="column is-9"></div>
            <div class="column is-4" data-tour-cat-step="1">
                <search-select v-if="selectedCategory == null"
                               reference="searchSelect"
                               :capitalized="true"
                               label="name"
                               optionText="Existing category"
                               placeholder="Type here"
                               :items="categories"
                               :loading="searchCat"
                               @change="onCategoryChanged"
                               @type="onType">
                </search-select>

                <bulma-input name="name" placeholder="Enter category name..." v-model="selectedCategory.name" v-else rules="required" disabled></bulma-input>
            </div>
            <div class="column is-3" v-if="selectedCategory == null" data-tour-cat-step="4">
                <div class="field" >
                    <div class="control">
                        <loading-button v-bind:loading="saving" color="is-primary" @click="addCategory()">Add</loading-button>
                    </div>
                </div>
            </div>
            <div class="column is-2" v-if="selectedCategory != null">
                <div class="field">
                    <div class="control">
                        <loading-button v-bind:loading="saving" color="is-info" @click="updateCategory()">Update</loading-button>
                    </div>
                </div>
            </div>
            <div class="column is-2" v-if="selectedCategory != null">
                <div class="field">
                    <div class="control">
                        <a class="button is-block is-danger" @click="showDeleteModal">Delete</a>
                    </div>
                </div>
            </div>
            <div class="column is-2" v-if="selectedCategory != null">
                <div class="field">
                    <div class="control">
                        <a class="button is-block is-warning" @click="cancelEditCategory()">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-multiline box" data-tour-cat-step="5">
            <div class="column">
                <p class="subtitle is-5" v-if="myCategories.length > 0">Your set:</p>
                <category-list  :categories="myCategories" @reordered="reordered" @click="selectCategory" :draggable="true"></category-list>
                <span class="help is-info" v-if="myCategories.length > 0">Click on category in order to edit it</span>
            </div>
        </div>
        <vue-tour :active="tourActive" :steps="tourSteps" btnDoneText="Next page" @onNextPage="nextPage" @onSkip="skipTour" @onStart="startTour"></vue-tour>
    </div>
</template>
<script>

    import _ from 'lodash'
    import Swatches from 'vue-swatches'
    import SearchSelect from '../components/util/SearchSelect.vue'
    import CategoryList from '../components/category/CategoryList.vue'

    export default {
        name: 'Categories',
        components: {Swatches, CategoryList, SearchSelect},
        data() {
            return {
                loading: false,
                searchCat : false,
                saving: false,
                categories:[],
                myCategories:[],
                category : {},
                selectedCategory: null,
                material: [
                    ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5'],
                    ['#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50'],
                    ['#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800'],
                    ['#FF5722', '#795548', '#9E9E9E', '#607D8B', '#3D4351'],
                ],
                color: '#3D4351',
                text_color: '#00d1b2',
                search : '',
                tourSteps: [
                    {
                        element: "[data-tour-cat-step='1']",
                        text: '<p class="has-text-justified">Let’s try to create a <strong>new </strong> category for your sentences. Simply enter the desired <strong>category</strong> name and click <strong class="has-text-primary"> Add</strong>. If you just want to try this function, try typing <em>“NEW CATEGORY”. </em> </p>'
                    },
                    {
                        element: "[data-tour-cat-step='2']",
                        text: '<p class="has-text-justified"><strong>Click  </strong>here to select the <em>new</em> <strong>background</strong> color for this category. Each <strong>category </strong> should be colored <em>differently</em> for maximum <strong>efficiency</strong>! <br><br><em>*You can also use <strong>HEX</strong> codes for custom colors </em> </p>'
                    },
                    {
                        element : "[data-tour-cat-step='3']",
                        text : '<p class="has-text-justified">Click <strong>here</strong> to select the <em>new</em> <strong>text</strong> color for this category, try creating <strong>contrast</strong> with your <em>background</em> color. <br><br><em>*White text is always a good starting choice.</em> </p>',
                    },
                    {
                        element: "[data-tour-cat-step='4']",
                        text: '<p class="has-text-justified"><strong>Click </strong> <strong class="has-text-primary"> Add</strong> button to <em>confirm</em> changes. </p>'
                    },
                    {
                        element: "[data-tour-cat-step='5']",
                        text: '<p class="has-text-justified"><strong>Click </strong> on any category to <em>customize </em> its colors. <strong>Click</strong> and<strong> Drag</strong> categories to change their order. <br><br><em>*Changing the <strong>order</strong> will also reflect the order they appear in the <strong class="has-text-primary"> New Feedback Section </strong> </em></p>'
                    },
                ],
            }
        },
        created(){
            this.loadPageData();
        },
        mounted(){
        },
        methods: {
            reordered(newCategories){
              this.myCategories = newCategories;
                this.userRepo.reorderCategory({ 'categories' : this.myCategories}).then(response => {
                    this.myCategories = response.data.data;
                }).catch((response) =>{
                    return Promise.reject(response);
                });
            },
            cancelEditCategory(){
                this.selectedCategory = null;
                this.color = '#3D4351';
                this.text_color ='#00d1b2';
            },
            onCategoryChanged(category){
                this.category = category;
            },
            selectCategory(category){
                this.selectedCategory = category;
                this.color = category.pivot.color;
                this.text_color = category.pivot.text_color;
            },
            onType(q){
                if(q.length >= 3 && q !== this.search){
                    this.search = q;
                    this.category = {};
                    this.searchCategories();
                    this.searchCat = true;
                }
            },
            searchCategories(){
                this.loading = true;
                this.categoryRepo.all(this.search).then(response => {
                    this.categories = response.data.data;
                    if(response.data.data){
                        this.categories = response.data.data;
                    }
                    else{
                        this.categories = [];
                    }
                    this.loading = false;
                    this.searchCat = false;
                }).catch((response) => {
                    this.loading = false;
                    this.searchCat = false;
                    return Promise.reject(response);
                });
            },

            loadPageData(){
                this.loading = true;
                let self = this;
                this.pageRepo.getCategoriesData(this.$route.path).then(response => {
                    let data = response.data.data;
                    this.loading = false;
                    this.myCategories = data.categories;

                    if(data.tour.show) {
                        this.tourActive = true;
                    }

                });
            },
            loadMyCategories(){
                let self = this;
                this.categoryRepo.userCategories().then(response => {
                    this.myCategories = response.data.data;
                }).catch((response) =>{
                    return Promise.reject(response);
                });
            },

            addCategory(){
                if(!this.category.id){
                    this.createCategory();
                }else{
                    this.attachCategory(this.category.id);
                }
            },

            createCategory(){
                this.saving = true;
                this.categoryRepo.store({name : this.search}).then(response => {
                    this.category = {};
                    this.search = "";
                    if(response.data.data.id){
                        this.attachCategory(response.data.data.id);
                    }
                }).catch((response)=>{
                    this.saving = false;
                    return Promise.reject(response);
                });
            },

            updateCategory(){
                let categoryPivot = {
                    color : this.color,
                    text_color : this.text_color,
                    order : this.selectedCategory.pivot.order
                };

                this.saving = true;
                this.userRepo.syncCategory(this.selectedCategory.id, categoryPivot).then(response => {
                    let self = this;
                    let index = _.indexOf(_.map(self.myCategories, 'id'), self.selectedCategory.id);
                    this.myCategories[index].pivot.color = this.color;
                    this.myCategories[index].pivot.text_color = this.text_color;

                    this.$toast.success(response.data.message);
                }).finally(()=>{
                    this.saving = false;
                });
            },

            attachCategory(id){
                let order = 1;
                if(this.myCategories && this.myCategories.length > 0){
                    order = this.myCategories[this.myCategories.length-1].pivot.order + 1;
                }
                let categoryPivot = {
                    color : this.color,
                    text_color : this.text_color,
                    order : order
                };

                this.saving = true;
                this.userRepo.attachCategory(id, categoryPivot).then(response => {
                    this.myCategories = response.data.data.categories;
                    this.$refs.searchSelect.refresh();
                    this.$toast.success(response.data.message);
                 }).catch((result) => {
                    //console.log(result);
                    this.$toast.error(result.data.message);
                }).finally(()=>{

                    this.saving = false;
                });
            },

            showDeleteModal(){
                let self = this;
                this.$swal({
                    title: 'Are you sure?',
                    text: "This category and all its sentences (" + this.selectedCategory.sentenceCount.value + ") will be permanently removed!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3273dc',
                    cancelButtonColor: '#ff3860',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result && result.value) {
                        self.detachCategory();
                    }
                }).catch((result) => {

                });

            },

            detachCategory(){
                let self = this;
                this.userRepo.detachCategory(this.selectedCategory.id).then(response => {
                    let self = this;
                    let index = _.indexOf(_.map(self.myCategories, 'id'), self.selectedCategory.id);
                    this.myCategories.splice(index, 1);
                    this.selectedCategory = null;
                    this.$swal(
                        'Deleted!',
                        'Your category has been deleted.',
                        'success'
                    )
                });
            },



        },
        watch: {

        }

    }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Categories.vue